import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-no-image",
  "use": "icon-no-image-usage",
  "viewBox": "0 0 560 274",
  "content": "<symbol viewBox=\"0 0 560 274\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-no-image\">\n<rect width=\"560\" height=\"274\" fill=\"#F2F3F5\" />\n<rect x=\"254\" y=\"111\" width=\"52\" height=\"52\" fill=\"#F2F3F5\" />\n<rect x=\"258.5\" y=\"118.5\" width=\"43\" height=\"37\" fill=\"#F2F3F5\" stroke=\"#E5E6EB\" stroke-width=\"3\" />\n<path d=\"M270 140.5C266.667 143.667 260 150.1 260 150.5V154.5H300V150L286.5 133.5L276 146L270 140.5Z\" fill=\"#E5E6EB\" />\n<circle cx=\"272\" cy=\"130\" r=\"5\" fill=\"#E5E6EB\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/no-image.svg
// module id = kxZM
// module chunks = 258